module.exports = __webpack_public_path__ + "Roboto-Bold.woff2?b52fac2bb93c5858f3f2675e4b52e1de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Bold/Roboto-Bold.woff2?v=2.137
// module id = 189
// module chunks = 7